export const V3IconRules = ({ }) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 4a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM3 8a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM8 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM2 4h6M2 8h1M2 12h6M11 4h3M6 8h8M11 12h3" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
